import  { useState } from "react";
import Display from "./Display";
import Buttons from "./Buttons";
import "./styles/Calculator.css";
import { evaluate, round } from "mathjs";

function Calculator() {
  const [input, setInput] = useState("");
  const [answer, setAnswer] = useState("");

  //input
  const inputHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (answer === "Invalid Input!!") return;
  
    const target = event.target as HTMLElement;
    let val = target.innerText;
  
    if (val === "x2") val = "^2";
    else if (val === "x3") val = "^3";
    else if (val === "3√") val = "^(1÷3)";
    else if (val === "log") val = "log(";
  
    const str = input + val;
    if (str.length > 14) return;
  
    if (answer !== "") {
      setInput(answer + val);
      setAnswer("");
    } else setInput(str);
  };
  
  //Clear screen
  const clearInput = () => {
    setInput("");
    setAnswer("");
  };

  // check brackets are balanced or not
  const checkBracketBalanced = (expr: string): boolean => {
    const stack: string[] = [];
    for (let i = 0; i < expr.length; i++) {
      const x = expr[i];
      if (x === "(") {
        stack.push(x);
        continue;
      }
  
      if (x === ")") {
        if (stack.length === 0) return false;
        else stack.pop();
      }
    }
    return stack.length === 0;
  };
  
  // calculate final answer
  const calculateAns = () => {
    if (input === "") return;
    let result: number | string = 0;  // result can now be a number or a string
      let finalexpression = input;
    //  finalexpression = input.replaceAll("^", "**");  //for eval()
    finalexpression = finalexpression.replaceAll("x", "*");
    finalexpression = finalexpression.replaceAll("÷", "/");

    // evaluate square root
    const noSqrt = input.match(/√[0-9]+/gi);

    if (noSqrt !== null) {
      let evalSqrt = input;
      for (let i = 0; i < noSqrt.length; i++) {
        evalSqrt = evalSqrt.replace(
          noSqrt[i],
          `sqrt(${noSqrt[i].substring(1)})`
        );
      }
      finalexpression = evalSqrt;
    }

    try {
      // check brackets are balanced or not
      if (!checkBracketBalanced(finalexpression)) {
        throw new Error("Brackets are not balanced!");
      }
      result = evaluate(finalexpression); // mathjs
    } catch (error) {
      if (error instanceof Error) {
        result = error.message === "Brackets are not balanced!"
          ? "Brackets are not balanced!"
          : "Invalid Input!!"; 
      } else {
        result = "Invalid Input!!";
      }
    }
  
    // Ensure setAnswer always receives a string
    setAnswer(typeof result === 'number' ? round(result, 3).toString() : result);
    };

  // remove last character
  const backspace = () => {
    if (answer !== "") {
      setInput(answer.toString().slice(0, -1));
      setAnswer("");
    } else setInput((prev) => prev.slice(0, -1));
  };

  // change prefix of expression
  const changePlusMinus = () => {
    //need to change for answer
    if (answer === "Invalid Input!!") return;
    else if (answer !== "") {
      const ans = answer.toString();
      if (ans.charAt(0) === "-") {
        const plus = "+";
        setInput(plus.concat(ans.slice(1, ans.length)));
      } else if (ans.charAt(0) === "+") {
        const minus = "-";
        setInput(minus.concat(ans.slice(1, ans.length)));
      } else {
        const minus = "-";
        setInput(minus.concat(ans));
      }
      setAnswer("");
    } else {
      if (input.charAt(0) === "-") {
        const plus = "+";
        setInput((prev) => plus.concat(prev.slice(1, prev.length)));
      } else if (input.charAt(0) === "+") {
        const minus = "-";
        setInput((prev) => minus.concat(prev.slice(1, prev.length)));
      } else {
        const minus = "-";
        setInput((prev) => minus.concat(prev));
      }
    }
  };

  return (
    <>
      <div className="bg-[#dfe9f5]">
        <div className="main">
          <Display input={input} setInput={setInput} answer={answer} />
          <Buttons
            inputHandler={inputHandler}
            clearInput={clearInput}
            backspace={backspace}
            changePlusMinus={changePlusMinus}
            calculateAns={calculateAns}
          />
        </div>
      </div>
    </>
  );
}

export default Calculator;
